import { Link } from "react-router-dom";
import { CallToAction } from "@shared/ui/CallToAction";
// import { VideoPlayer } from "@shared/ui/VideoPlayer";
// import captionsUrl from "@shared/assets/captions/Pollinator-HowItWorks-web.vtt";
import { Type } from "@shared/ui/Type";
import { MarketingSection } from "../MarketingSection/MarketingSection";
import { useSignupDisabled } from "@platform/hooks/useSignupDisabled";
import { usePlatformClosed } from "@platform/hooks/usePlatformClosed";

type Props = {
  onCodeLinkClick: () => void;
  onOrgLookupClick: () => void;
  onNewsletterClick?: () => void;
  onLoginClick?: () => void;
};

export function MarketingHeroNoInvitation({
  onCodeLinkClick,
  onOrgLookupClick,
  onNewsletterClick,
  onLoginClick,
}: Props) {
  const isSignupDisabled = useSignupDisabled();
  const isPlatformClosed = usePlatformClosed();

  return (
    <MarketingSection id="hero">
      <div className="flex flex-col gap-4 md:gap-6">
        <Type as="h1" variant="h1">
          Pollinator is a growing network of aligned peers.
        </Type>
        <Type as="p" variant="body1">
          With thousands of enrolled participants across 120+ vetted
          organizations focused on art, technology, and social impact, we are
          weaving an interdisciplinary web of mutual support.
        </Type>
        <Type as="p" variant="body1">
          The 2025 Pilot Program is now closed.{" "}
          <Link to="#program" className="underline hover:text-brand-700">
            Read more
          </Link>
          .
        </Type>
      </div>
      {!isSignupDisabled && (
        <CallToAction
          title="Join a peer circle for five weeks of focused creative momentum."
          variant="platform"
          onPrimaryClick={onCodeLinkClick}
          onSecondaryClick={onOrgLookupClick}
          secondaryButtonText="No code?"
          primaryButtonText="Sign up with a code"
        />
      )}
      {!isPlatformClosed && (
        <CallToAction
          title="Participating in 2025?"
          variant="platform"
          onPrimaryClick={onLoginClick}
          primaryButtonText="Log in"
        />
      )}
      <CallToAction
        title="Want to join us?"
        description="Alumni of organizations in our growing network can join Pollinator in 2026. Subscribe to our newsletter to be notified."
        variant="platform"
        onPrimaryClick={onNewsletterClick}
        primaryButtonText="Subscribe to our newsletter"
        theme="light"
      />
      {/* <VideoPlayer
        src="https://static.pollinator.coop/video/Pollinator-HowItWorks-web.mp4"
        poster="https://static.pollinator.coop/images/posters/vid-cap3.jpg"
        captionsUrl={captionsUrl}
        className="rounded-lg"
        controls={true}
        autoPlayOnMute={true}
        loop={true}
        title="Pollinator: Learn more"
      /> */}
    </MarketingSection>
  );
}

export default MarketingHeroNoInvitation;
